import { useEffect } from 'react';

export function useBodyLock(isLocked: boolean): void {
  useEffect(() => {
    if (!isLocked) return;
    const root = document.getElementById('root');
    if (!root) return;
    const scrollTop = root.scrollTop;
    root.style.overflowY = 'hidden';
    return () => {
      root.style.overflowY = '';
      root.scrollTop = scrollTop;
    };
  }, [isLocked]);
}
